module.exports = __webpack_public_path__ + "img/product-shot_05.a9705344.jpg";